import AuctionHouseDetails from "./AuctionHouseDetails";

export default AuctionHouseDetails;
